import * as Types from '../../../../../graphql.generated';

export type FetchUserWithTrackedPropertiesQueryVariables = Types.Exact<{
    [key: string]: never;
}>;

export type FetchUserWithTrackedPropertiesQuery = { __typename?: 'Query' } & {
    user?: Types.Maybe<
        { __typename?: 'User' } & Pick<
            Types.User,
            | 'loggedIn'
            | 'name'
            | 'email'
            | 'status'
            | 'senderPropertyStatus'
            | 'userId'
            | 'userUuid'
            | 'creationDate'
            | 'brandPrimary'
            | 'registrationSources'
            | 'registered'
        > & {
                profile?: Types.Maybe<
                    { __typename?: 'UserProfile' } & Pick<
                        Types.UserProfile,
                        'situationWhatIsYourCurrentPropertyGoal'
                    >
                >;
                traits?: Types.Maybe<
                    { __typename?: 'Traits' } & Pick<
                        Types.Traits,
                        | 'yourSituationSkipped'
                        | 'situationModuleLastShownAt'
                        | 'situationLastUpdatedAt'
                    >
                >;
                trackedProperties?: Types.Maybe<
                    { __typename?: 'UserTrackedProperties' } & Pick<
                        Types.UserTrackedProperties,
                        'total'
                    > & {
                            items: Array<
                                { __typename?: 'UserTrackedProperty' } & Pick<
                                    Types.UserTrackedProperty,
                                    'relationship'
                                > & {
                                        property: {
                                            __typename?: 'Property';
                                        } & Pick<Types.Property, 'uprn'> & {
                                                address?: Types.Maybe<
                                                    {
                                                        __typename?: 'Address';
                                                    } & Pick<
                                                        Types.Address,
                                                        'fullAddress' | 'uprn'
                                                    >
                                                >;
                                            };
                                        permissions?: Types.Maybe<
                                            {
                                                __typename?: 'Permissions';
                                            } & Pick<
                                                Types.Permissions,
                                                'hasPermissions'
                                            >
                                        >;
                                    }
                            >;
                        }
                >;
            }
    >;
};

export const FetchUserWithTrackedPropertiesDocument = `
    query fetchUserWithTrackedProperties {
  user {
    loggedIn
    name
    email
    status
    senderPropertyStatus
    userId
    userUuid
    creationDate
    brandPrimary
    registrationSources
    registered
    profile {
      situationWhatIsYourCurrentPropertyGoal
    }
    traits {
      yourSituationSkipped
      situationModuleLastShownAt
      situationLastUpdatedAt
    }
    trackedProperties(offset: 0, limit: 1) {
      total
      items {
        relationship
        property {
          uprn
          address {
            fullAddress
            uprn
          }
        }
        permissions {
          hasPermissions
        }
      }
    }
  }
}
    `;
export type Requester<C = {}, E = unknown> = <R, V>(
    doc: string,
    vars?: V,
    options?: C
) => Promise<R>;
export function getSdk<C, E>(requester: Requester<C, E>) {
    return {
        fetchUserWithTrackedProperties(
            variables?: FetchUserWithTrackedPropertiesQueryVariables,
            options?: C
        ): Promise<FetchUserWithTrackedPropertiesQuery> {
            return requester<
                FetchUserWithTrackedPropertiesQuery,
                FetchUserWithTrackedPropertiesQueryVariables
            >(FetchUserWithTrackedPropertiesDocument, variables, options);
        }
    };
}
export type Sdk = ReturnType<typeof getSdk>;
